import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatRippleModule } from '@angular/material/core';
import { MatIconModule } from '@angular/material/icon';
import { FormatDatePipe } from '@ildes/pipes/format-date.pipe';
import { ContextualActionComponent } from '../contextual-action/contextual-action.component';
import { HumanizeStateComponent } from '../humanize-state/humanize-state.component';

@Component({
  selector: 'list-user-pqrs-item',
  standalone: true,
  imports: [
    CommonModule,
    MatButtonModule,
    MatIconModule,
    FormatDatePipe,
    MatRippleModule,
    ContextualActionComponent,
    HumanizeStateComponent
  ],
  template: `
  <div class="flex-1" mat-ripple (click)="emitClickItem()">
    <div>
      <div class="header padding-bottom-8">
        <div class="luminary-number">
          <span class="name">{{id}}</span>
        </div>
        <div class="padding-bottom-8 padding-top-8">
          <span class="project">{{project}}</span>
        </div>
        <div>
          <humanize-state [state]="state"></humanize-state>
        </div>
      </div>
      <div class="container">
        <div class="data">
          <div class="margin-right-16 basic-data">
            <div class="subtitle-description">
              {{description}}
            </div>
            <div class="icon-text">
              <mat-icon>calendar_today</mat-icon> <span> Fecha de entrada: {{createdAt | formatDate}} </span>
            </div>
            <div *ngIf="address">
              <div class="subtitle ubication icon-text">
                <mat-icon>room</mat-icon> <span> {{address}}. {{city}} ({{department}}) </span>
              </div>
            </div>
            <div class="icon-text">
              <mat-icon>face</mat-icon> <span>Contacto: {{this.name}} {{this.surname}}</span>
            </div>
            <div class="subtitle icon-text">
              <span>Medio de contacto: {{email}}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="actions" *ngIf="actions">
    <contextual-action [actions]="actions" [collapseAll]="true" (actionEvent)="onActionClick.emit($event)"></contextual-action>
  </div>
  `,
  styleUrls: ['./list-user-pqrs-item.component.css'],
})
export class ListUserPqrsItemComponent {
  @Input() name;
  @Input() surname;
  @Input() state;
  @Input() email;
  @Input() address;
  @Input() description;
  @Input() id;
  @Input() project;
  @Input() createdAt;
  @Input() city;
  @Input() department;
  @Input() actions;

  @Output() onActionClick = new EventEmitter();
  @Output() onClick = new EventEmitter();

  emitClickItem() {
    this.onClick.emit();
  }

}
